export default class ProductsLanding {
	private categoryEl: HTMLCollectionOf<Element>;

	constructor() {
		if (!document.getElementsByClassName('__products').length)
			return;

		// NOTE: We only need this for the flexbox version to achieve
		// consistent heights across rows. -SB 2017-11-10
		if (document.getElementsByClassName('no-flexboxlegacy').length) {
			this.categoryEl = document.getElementsByClassName('productCategory');
			this.equalizeHeights(this.categoryEl);
		}
	}

	private equalizeHeights(el: HTMLCollection): void {
		if (!el.length)
		return;

		let accumulator: number = 0;
		for (let i: number = 0; i < el.length; i++) {
			const element: Element = el[i] as Element;
			const elHeight: number = element.getBoundingClientRect().height;
			if (elHeight > accumulator) {
				accumulator = elHeight;
			}
		}

		for (let i: number = 0; i < el.length; i++) {
			const element: HTMLElement = el[i] as HTMLElement;
			element.style.height = accumulator.toString(10) + 'px';
			console.log(element.style.height);
		}
	}
}